export const SHOW_CONFIRMATION_MODAL = 'SHOW_CONFIRMATION_MODAL'
export const HIDE_CONFIRMATION_MODAL = 'HIDE_CONFIRMATION_MODAL'
